/**
 * Admin Dashboard - Properties Table
 */
import { Link } from "react-router-dom";
import { Edit, Trash2, Eye, Star, MoreVertical } from "lucide-react";
import { Button } from "@/components/ui/button";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

const PropertiesTable = ({ properties = [], onDelete, formatPrice }) => {
  if (properties.length === 0) {
    return (
      <div className="text-center py-12 text-[#A3A3A3]">
        <p>No hay propiedades registradas</p>
        <Link to="/admin/propiedades/nueva" className="text-[#D4AF37] hover:underline mt-2 inline-block">
          Agregar primera propiedad
        </Link>
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-white/5">
            <th className="text-left py-3 px-4 text-[#A3A3A3] text-sm font-medium">Propiedad</th>
            <th className="text-left py-3 px-4 text-[#A3A3A3] text-sm font-medium hidden md:table-cell">Tipo</th>
            <th className="text-left py-3 px-4 text-[#A3A3A3] text-sm font-medium hidden lg:table-cell">Ubicación</th>
            <th className="text-left py-3 px-4 text-[#A3A3A3] text-sm font-medium">Precio</th>
            <th className="text-right py-3 px-4 text-[#A3A3A3] text-sm font-medium">Acciones</th>
          </tr>
        </thead>
        <tbody>
          {properties.map((property) => (
            <tr key={property.id} className="border-b border-white/5 hover:bg-white/5">
              <td className="py-4 px-4">
                <div className="flex items-center gap-3">
                  {property.images?.[0]?.url ? (
                    <img 
                      src={property.images[0].url} 
                      alt={property.name}
                      className="w-12 h-12 rounded object-cover"
                    />
                  ) : (
                    <div className="w-12 h-12 rounded bg-white/5 flex items-center justify-center text-[#A3A3A3]">
                      No img
                    </div>
                  )}
                  <div>
                    <p className="text-white font-medium flex items-center gap-2">
                      {property.name}
                      {property.is_featured && <Star size={14} className="text-[#D4AF37] fill-current" />}
                    </p>
                    <p className="text-[#A3A3A3] text-sm md:hidden">{property.property_type}</p>
                  </div>
                </div>
              </td>
              <td className="py-4 px-4 hidden md:table-cell">
                <span className="text-[#A3A3A3]">{property.property_type}</span>
                <span className={`ml-2 px-2 py-0.5 text-xs rounded ${
                  property.transaction_type === "Venta" ? "bg-green-500/20 text-green-400" : "bg-blue-500/20 text-blue-400"
                }`}>
                  {property.transaction_type}
                </span>
              </td>
              <td className="py-4 px-4 hidden lg:table-cell text-[#A3A3A3]">
                {property.zone}, {property.department}
              </td>
              <td className="py-4 px-4 text-[#D4AF37] font-mono">
                {formatPrice ? formatPrice(property.price_usd) : `$${property.price_usd?.toLocaleString()}`}
              </td>
              <td className="py-4 px-4 text-right">
                <DropdownMenu>
                  <DropdownMenuTrigger asChild>
                    <Button variant="ghost" size="icon" className="text-[#A3A3A3] hover:text-white">
                      <MoreVertical size={18} />
                    </Button>
                  </DropdownMenuTrigger>
                  <DropdownMenuContent align="end" className="bg-[#121212] border-white/10">
                    <DropdownMenuItem asChild>
                      <Link to={`/propiedad/${property.slug || property.id}`} className="flex items-center gap-2">
                        <Eye size={14} /> Ver
                      </Link>
                    </DropdownMenuItem>
                    <DropdownMenuItem asChild>
                      <Link to={`/admin/propiedades/${property.id}`} className="flex items-center gap-2">
                        <Edit size={14} /> Editar
                      </Link>
                    </DropdownMenuItem>
                    <DropdownMenuItem 
                      onClick={() => onDelete(property.id)} 
                      className="text-red-400 focus:text-red-400"
                    >
                      <Trash2 size={14} className="mr-2" /> Eliminar
                    </DropdownMenuItem>
                  </DropdownMenuContent>
                </DropdownMenu>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default PropertiesTable;
